import React from 'react';
import { Bookmark, Share2, MoreVertical } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

/**
 * PollFooter (V3.0 - Minimalist Industrial Spec)
 * Rebuilt to match the spec image: • LIVE on far left, Utilities on far right.
 */
const PollFooter = ({
    id,
    onShare,
    onOpenMenu,
    inModal = false,
    isSaved = false,
    onBookmarkToggle
}) => {
    const { isVerified, setIsEnrollmentOpen } = useAuth();

    const toggleBookmark = (e) => {
        e.stopPropagation();
        if (!isVerified) {
            window.dispatchEvent(new CustomEvent('open-enrollment'));
            return;
        }
        if (onBookmarkToggle) {
            onBookmarkToggle(id);
        }
    };

    return (
        <div className={`w-full bg-gray-50/50 dark:bg-[#111827]/40 backdrop-blur-xl border-t border-gray-100 dark:border-white/5 px-6 py-4 flex items-center justify-between select-none z-10 ${inModal ? 'sticky bottom-0 rounded-none' : ''}`}>

            {/* LEFT: LIVE STATUS */}
            <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse shadow-[0_0_8px_rgba(239,68,68,0.5)]" />
                <span className="text-2xs font-black text-gray-500 dark:text-gray-500 uppercase tracking-[0.2em]">Live</span>
            </div>

            {/* RIGHT: UTILITY ICONS */}
            <div className="flex items-center gap-6 text-gray-500 dark:text-gray-500">
                <button
                    onClick={toggleBookmark}
                    className="hover:text-gray-900 dark:hover:text-white transition-colors duration-200"
                    title="Bookmark"
                    aria-label={isSaved ? 'Remove bookmark' : 'Bookmark this poll'}
                    aria-pressed={isSaved}
                >
                    <Bookmark size={18} className={isSaved ? 'fill-gray-900 text-gray-900 dark:fill-white dark:text-white' : ''} />
                </button>
                <button
                    onClick={(e) => { e.stopPropagation(); onShare(); }}
                    className="hover:text-gray-900 dark:hover:text-white transition-colors duration-200"
                    title="Share"
                    aria-label="Share this poll"
                >
                    <Share2 size={18} />
                </button>
                <button
                    onClick={(e) => { e.stopPropagation(); onOpenMenu && onOpenMenu(); }}
                    className="hover:text-gray-900 dark:hover:text-white transition-colors duration-200"
                    title="Menu"
                    aria-label="More options"
                >
                    <MoreVertical size={18} />
                </button>
            </div>
        </div>
    );
};

export default PollFooter;
